__turbopack_context__.v({
  "accreditation": "Card-module-scss-module__byEC9W__accreditation",
  "add-field-btn": "Card-module-scss-module__byEC9W__add-field-btn",
  "add-field-btn-container": "Card-module-scss-module__byEC9W__add-field-btn-container",
  "base-lock": "Card-module-scss-module__byEC9W__base-lock",
  "card": "Card-module-scss-module__byEC9W__card",
  "card-body": "Card-module-scss-module__byEC9W__card-body",
  "card-container": "Card-module-scss-module__byEC9W__card-container",
  "card-edit-section-header": "Card-module-scss-module__byEC9W__card-edit-section-header",
  "card-edit-section-label-and-lock": "Card-module-scss-module__byEC9W__card-edit-section-label-and-lock",
  "card-edit-subsection": "Card-module-scss-module__byEC9W__card-edit-subsection",
  "card-field": "Card-module-scss-module__byEC9W__card-field",
  "card-field-btn": "Card-module-scss-module__byEC9W__card-field-btn",
  "card-field-outline": "Card-module-scss-module__byEC9W__card-field-outline",
  "card-item": "Card-module-scss-module__byEC9W__card-item",
  "card-item-icon-circle": "Card-module-scss-module__byEC9W__card-item-icon-circle",
  "card-items": "Card-module-scss-module__byEC9W__card-items",
  "card-loader": "Card-module-scss-module__byEC9W__card-loader" + " " + "Card-module-scss-module__byEC9W__card",
  "card-loader-container": "Card-module-scss-module__byEC9W__card-loader-container",
  "card-loader-details-section": "Card-module-scss-module__byEC9W__card-loader-details-section",
  "card-loader-field-container": "Card-module-scss-module__byEC9W__card-loader-field-container",
  "card-loader-field-details": "Card-module-scss-module__byEC9W__card-loader-field-details",
  "card-loader-field-icon": "Card-module-scss-module__byEC9W__card-loader-field-icon",
  "card-loader-header": "Card-module-scss-module__byEC9W__card-loader-header",
  "card-loader-long-section": "Card-module-scss-module__byEC9W__card-loader-long-section",
  "card-loader-med-section": "Card-module-scss-module__byEC9W__card-loader-med-section",
  "card-loader-small-section": "Card-module-scss-module__byEC9W__card-loader-small-section",
  "card-measurer": "Card-module-scss-module__byEC9W__card-measurer",
  "delete-field-btns": "Card-module-scss-module__byEC9W__delete-field-btns",
  "delete-field-warning": "Card-module-scss-module__byEC9W__delete-field-warning",
  "delete-field-warning-heading": "Card-module-scss-module__byEC9W__delete-field-warning-heading",
  "drag-to-reorder-handle": "Card-module-scss-module__byEC9W__drag-to-reorder-handle",
  "edit-card-field-popover": "Card-module-scss-module__byEC9W__edit-card-field-popover",
  "edit-card-field-popover-btns": "Card-module-scss-module__byEC9W__edit-card-field-popover-btns",
  "edit-card-field-popover-save-cancel-btns": "Card-module-scss-module__byEC9W__edit-card-field-popover-save-cancel-btns",
  "edit-icon": "Card-module-scss-module__byEC9W__edit-icon",
  "extra-information-icon": "Card-module-scss-module__byEC9W__extra-information-icon",
  "extra-information-icon-circle": "Card-module-scss-module__byEC9W__extra-information-icon-circle",
  "extra-information-item": "Card-module-scss-module__byEC9W__extra-information-item",
  "extra-information-list": "Card-module-scss-module__byEC9W__extra-information-list",
  "extra-information-value": "Card-module-scss-module__byEC9W__extra-information-value",
  "lock": "Card-module-scss-module__byEC9W__lock" + " " + "Card-module-scss-module__byEC9W__base-lock",
  "lock-all-fields-btn": "Card-module-scss-module__byEC9W__lock-all-fields-btn",
  "lock-icon": "Card-module-scss-module__byEC9W__lock-icon",
  "lock-message-fade-in": "Card-module-scss-module__byEC9W__lock-message-fade-in",
  "notification-icon": "Card-module-scss-module__byEC9W__notification-icon",
  "save-btn-container": "Card-module-scss-module__byEC9W__save-btn-container",
  "save-btn-sentinel": "Card-module-scss-module__byEC9W__save-btn-sentinel",
  "user-accreditations": "Card-module-scss-module__byEC9W__user-accreditations",
  "user-accreditations-container": "Card-module-scss-module__byEC9W__user-accreditations-container",
  "user-company": "Card-module-scss-module__byEC9W__user-company",
  "user-company-container": "Card-module-scss-module__byEC9W__user-company-container",
  "user-department": "Card-module-scss-module__byEC9W__user-department",
  "user-department-container": "Card-module-scss-module__byEC9W__user-department-container",
  "user-details": "Card-module-scss-module__byEC9W__user-details",
  "user-headline": "Card-module-scss-module__byEC9W__user-headline",
  "user-headline-container": "Card-module-scss-module__byEC9W__user-headline-container",
  "user-job-title": "Card-module-scss-module__byEC9W__user-job-title",
  "user-job-title-container": "Card-module-scss-module__byEC9W__user-job-title-container",
  "user-name": "Card-module-scss-module__byEC9W__user-name",
  "user-name-container": "Card-module-scss-module__byEC9W__user-name-container",
  "user-pronouns": "Card-module-scss-module__byEC9W__user-pronouns",
});
